<div class="db-preview-container">
    <div *ngIf="!overviewMode" class="db-preview-header-wrapper px-3 pt-5 pb-3">
        <div class="db-preview-title">
            <h3 class="primary-text lighter-text">
                {{ dbname}}
            </h3>
        </div>
        <div class="db-preview-header" #moreOptions>
            <div class="db-preview-header-1">
                <div class="icon-div" (click)="refreshWidget()">
                    <img src="assets/widgets/refresh.svg" tooltip="Refresh" class="tooltip-enable enable-action" />
                </div>
            </div>
            <div class="db-preview-header-2">
                <div class="icon-div" #colorPalateOrigin (click)="
            openOverlay_templateRef(
              colorPalateRef,
              colorPalateOrigin,
              'colorpalate'
            )
          ">
                    <img src="assets/widgets/edit-color.svg" [tooltip]="moreoptiontitles[5]" class="enable-action tooltip-enable" />
                </div>
            </div>
            <div class="db-preview-header-3">
                <div class="icon-div" #filterOrigin (click)="
            openOverlay_templateRef(dateFilterRef, filterOrigin, 'datefilter')
          ">
                    <img src="assets/widgets/filter.svg" [tooltip]="moreoptiontitles[3]" class="enable-action tooltip-enable" />
                </div>
            </div>
            <div class="db-preview-header-4">
                <div class="icon-div" (click)="closePreviewClick()">
                    <img src="assets/widgets/close-dialog.svg" tooltip="close" class="enable-action close-dialog tooltip-enable" />
                </div>
            </div>
        </div>
    </div>
    <div #child class="db-preview-grid-area" [ngClass]="[dashboardBuilderVarService.dashboard_preview_mode == 'preview'?'new-preview-grid-area-height':'landing-preview-grid-area-height',dashboardBuilderVarService.dashboardMode ? 'dashboardHeight pl-3 pr-1': '',overviewMode ? 'overview-grid-area-height':'']">
        <gridstack [options]="widgetGridOptions">
            <gridstack-item *ngFor="let widget of gridChildren" [options]="widget" [class.not-label]="widget.input.data.type != 'label'">
                <app-chart-widget #chart *ngIf="
            widget.input.data.type != 'label' &&
            widget.input.data.type != 'table'
          " [data]="widget.input.widgetdata" [mode]="widget.input.mode" [widgetId]="widget.input.widgetId" [widgetInfo]="widget.input.data" [preview_subtitle]="subtitle"></app-chart-widget>
                <app-chart-label #chart *ngIf="widget.input.data.type == 'label'" [data]="widget.input.widgetdata" [mode]="widget.input.mode" [widgetId]="widget.input.widgetId" [widgetInfo]="widget.input.data"></app-chart-label>
                <app-chart-table #chart *ngIf="widget.input.data.type == 'table'" [data]="widget.input.widgetdata" [mode]="widget.input.mode" [widgetId]="widget.input.widgetId" [widgetInfo]="widget.input.data" [preview_subtitle]="subtitle"></app-chart-table>
            </gridstack-item>
        </gridstack>
    </div>
</div>

<ng-template #colorPalateRef>
    <div class="edit_color_palet primary-bg radius-m module-chip-shadow">
        <div class="color-container primary-bg p-5 radius-s">
            <ng-container *ngFor="
          let colors of widgetBuilderVarService.colorPalette;
          let i = index
        ">
                <div>
                    <div class="color-1 p-1" [ngClass]="i == selectedColorIndex ? 'color-planel-highlight' : ''" (click)="colorPalatte_click(colors, i)">
                        <ng-container *ngFor="let color of colors">
                            <span class="pix" [ngStyle]="{ 'background-color': color }"></span>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<!-- <ng-template #dateFilterRef>
    <div class="more-option-filter-container border-light  primary-bg radius-m lighter-text dropdown-shadow ">
        <div class="more-option-filter">
            <div class="filter-header-wrapper radius-m primary-bg pt-6 px-6">
                <ul id="dateFilter" class="span-m primary-text m-0 p-0">
                    <ng-container
                        *ngFor="let filter of dashboardBuilderVarService.relativeTimeMetadata; let i = index">
                        <li class="li-m" (click)="relativeTimeClick('dateFilter',filter.value,'relativetime')">
                            {{ filter.disp }} </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</ng-template> -->

<ng-template #dateFilterRef>
    <div class="more-option-filter-container border-light primary-bg radius-m lighter-text dropdown-shadow">
        <div class="more-option-filter">
            <div class="filter-header-wrapper radius-m primary-bg pt-6 px-6">
                <ul id="dateFilter" class="span-m primary-text m-0 p-0">
                    <ng-container *ngFor="
              let filter of dashboardBuilderVarService.relativeTimeMetadata;
              let i = index
            ">
                        <li class="li-m" (click)="
                relativeTimeClick('dateFilter', filter.value, 'relativetime')
              ">
                            {{ filter.disp }}
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="seperator border-light-bottom radius-m mx-6"></div>
            <div class="filter-body-wrapper pb-6 px-6 radius-m">
                <form [formGroup]="selectTime">
                    <div class="filter-body-row-1">
                        <p class="primary-text content-l">From</p>
                        <input class="primary-bg input-border input-m primary-text tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [max]="maxdate" tooltip="{{
                selectTime.controls.toDate.value | date : 'dd MMM yy'
              }}" style="cursor: pointer" />
                    </div>
                    <div class="filter-body-row-2">
                        <p class="primary-text content-l">To</p>
                        <input class="primary-bg input-border input-m primary-text tooltip-enable border-none" type="date" id="from" formControlName="toDate" [max]="maxdate" tooltip="{{
                selectTime.controls.toDate.value | date : 'dd MMM yy'
              }}" style="cursor: pointer" />
                    </div>
                    <button class="apply submit" (click)="dateFilterClick()">
            Apply
          </button>
                    <span class="date-validation alert-text span-s" *ngIf="selectTime.errors">
            {{
              sharedService.metaData.rule.lookbackmeta.formerrormsg.invalidtime
            }}
          </span>
                </form>
            </div>
        </div>
    </div>
</ng-template>